import FaqAccordion from "@/components/feature/FaqAccordion";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqs } from "@/mocks/guaData";

export default function HomeFaq() {
  return (
    <section className="w-full bg-background-100/60" aria-labelledby="faq-title">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-12 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="常见问题"
          title="关于榜单和内容，你可能会想问"
          description="如果这里没有解答你的疑问，欢迎通过“关于我们”页面的邮箱直接找我们。"
        />
        <div className="mt-8">
          <FaqAccordion items={faqs} />
        </div>
      </div>
    </section>
  );
}